import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust this import path as needed

const fetchDataByTopic = async (collectionName) => {
  try {
    const querySnapshot = await getDocs(collection(db, collectionName));
    const items = {};

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      const topic = data.Topic || 'Uncategorized';

      if (!items[topic]) {
        items[topic] = [];
      }

      items[topic].push({
        id: doc.id,
        ...data
      });
    });

    console.log(`Fetched ${collectionName} data:`, items);
    return items;
  } catch (error) {
    console.error(`Error fetching ${collectionName}:`, error);
    throw error;
  }
};

export const fetchFAQs = () => fetchDataByTopic('faqs');
export const fetchUtterances = () => fetchDataByTopic('utterances');
export const fetchAnswers = () => fetchDataByTopic('answers');